import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --container-padding: 20px;
    --section-padding: 40px;
  }

  body {
    font-family: var(--font-primary);
    line-height: 1.6;
    color: #333;
    overflow-x: hidden;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 var(--container-padding);
    width: 100%;
  }

  .section {
    padding: var(--section-padding) 0;
  }

  .section-dark {
    background-color: #f8f9fa;
  }

  .section-light {
    background-color: #ffffff;
  }

  .section-title {
    font-size: 2.5rem;
    margin-bottom: 40px;
    text-align: center;
    color: #2c3e50;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-primary);
    margin-bottom: 1rem;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    :root {
      --container-padding: 16px;
      --section-padding: 32px;
    }

    .section-title {
      font-size: 2rem;
      margin-bottom: 24px;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.75rem;
    }

    h3 {
      font-size: 1.5rem;
    }

    p {
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    :root {
      --container-padding: 12px;
      --section-padding: 24px;
    }

    .section-title {
      font-size: 1.75rem;
      margin-bottom: 20px;
    }

    h1 {
      font-size: 1.75rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    h3 {
      font-size: 1.25rem;
    }
  }
`;

export default GlobalStyles; 